var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v("\n  EMBED URL\n  "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.dataSetup.title.$error } },
        [
          _c("label", [_vm._v(" Title ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { "max-length": 255, placeholder: "Title" },
            model: {
              value: _vm.$v.dataSetup.title.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.dataSetup.title, "$model", $$v)
              },
              expression: "$v.dataSetup.title.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        { class: { "error-input": _vm.$v.dataSetup.url.$error } },
        [
          _c("label", [_vm._v(" Url ")]),
          _vm._v(" "),
          _c("j-input", {
            attrs: { placeholder: "https://" },
            model: {
              value: _vm.$v.dataSetup.url.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.dataSetup.url, "$model", $$v)
              },
              expression: "$v.dataSetup.url.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _c(
              "div",
              { staticClass: "float-to-right" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn gray m__r--5",
                    on: { click: _vm.closeForm }
                  },
                  [_vm._v("\n          Close\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  { staticClass: "btn blue", on: { click: _vm.saveForm } },
                  [_vm._v("\n          Save\n        ")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "warning-message" }, [
      _c("img", { attrs: { src: require("@/assets/icon/warning.svg") } }),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column" }, [
        _c("p", { staticClass: "warning-title" }, [_vm._v("Information")]),
        _vm._v(" "),
        _c("p", { staticClass: "warning-info" }, [
          _vm._v(
            "\n        URL must use HTTPS (Hypertext Transfer Protocol Secure)\n      "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58992b07", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58992b07","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/widget-component/jEmbedUrlSetup.vue
// module id = null
// module chunks = 